import { createSelector } from '@reduxjs/toolkit';

import { getLocationsSelectorArgs } from './getRegionSelector';

export const getDeviceFromParamSelector = createSelector(
  [
    getLocationsSelectorArgs,
    (state, props: { deviceId?: string; workspaceId: string | undefined }) =>
      props.deviceId,
  ],
  (locations, deviceId) =>
    locations?.data?.devices.find((item) => item.uuid === deviceId)
);
